"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPublishMethod = isPublishMethod;
exports.isPublishParams = isPublishParams;
exports.isPublishRequest = isPublishRequest;
exports.isSubscribeMethod = isSubscribeMethod;
exports.isSubscribeParams = isSubscribeParams;
exports.isSubscribeRequest = isSubscribeRequest;
exports.isSubscriptionMethod = isSubscriptionMethod;
exports.isSubscriptionParams = isSubscriptionParams;
exports.isSubscriptionRequest = isSubscriptionRequest;
exports.isUnsubscribeMethod = isUnsubscribeMethod;
exports.isUnsubscribeParams = isUnsubscribeParams;
exports.isUnsubscribeRequest = isUnsubscribeRequest;

var _misc = require("./misc");

function isSubscribeRequest(request) {
  return isSubscribeMethod(request.method) && isSubscribeParams(request.params);
}

function isSubscribeMethod(method) {
  return (0, _misc.methodEndsWith)(method, "subscribe");
}

function isSubscribeParams(params) {
  var required = ["topic"];
  var optional = [];
  return (0, _misc.checkParams)(params, required, optional);
}

function isPublishRequest(request) {
  return isPublishMethod(request.method) && isPublishParams(request.params);
}

function isPublishMethod(method) {
  return (0, _misc.methodEndsWith)(method, "publish");
}

function isPublishParams(params) {
  var required = ["message", "topic", "ttl"];
  var optional = ["prompt", "tag"];
  return (0, _misc.checkParams)(params, required, optional);
}

function isUnsubscribeRequest(request) {
  return isUnsubscribeMethod(request.method) && isUnsubscribeParams(request.params);
}

function isUnsubscribeMethod(method) {
  return (0, _misc.methodEndsWith)(method, "unsubscribe");
}

function isUnsubscribeParams(params) {
  var required = ["id", "topic"];
  var optional = [];
  return (0, _misc.checkParams)(params, required, optional);
}

function isSubscriptionRequest(request) {
  return isSubscriptionMethod(request.method) && isSubscriptionParams(request.params);
}

function isSubscriptionMethod(method) {
  return (0, _misc.methodEndsWith)(method, "subscription");
}

function isSubscriptionParams(params) {
  var required = ["id", "data"];
  var optional = [];
  return (0, _misc.checkParams)(params, required, optional);
}